import { TProps } from './types/TProps';

const placeholderLayoutClassName = 'label pointer-events-none absolute left-4 top-1/2 -translate-y-1/2';

const selectedLayoutClassName = 'label label--selected';

const placeholderTextClassName = '!text-[var(--color-form-field-placeholder,var(--color-text-muted))]';

const selectedTextClassName = '!text-[var(--color-form-field-text,var(--color-text-muted))]';

const disabledTextClassName = '!text-[var(--color-form-field-disabled-text)]';

export const FormFieldSelectLabel = ({ selected = false, disabled = false, className = '', children }: TProps) => {
  const layoutClassName = selected ? selectedLayoutClassName : placeholderLayoutClassName;
  const textClassName = disabled ? disabledTextClassName : selected ? selectedTextClassName : placeholderTextClassName;

  return <span className={[layoutClassName, textClassName, className].filter(Boolean).join(' ')}>{children}</span>;
};
